/* eslint-disable */
import type { RateTypeV1 } from '../hotel/hotel_common';
import type { PreferredLocationLabel, TravelClass } from './common';

/** Multiple choices for CoachPref. */
export enum CoachPref {
  COACH_PREF_UNKNOWN = 0,
  SMOKING = 1,
  NON_SMOKING = 2,
  PETS_ALLOWED = 3,
  RESTAURANT = 4,
  QUIET = 5,
  UNRECOGNIZED = -1,
}

export interface RailPref {
  /** Rail stations preferred by user. */
  preferredRailStations: PreferredRailStation[];
  /** Preferred seat. */
  seatPref?: SeatPref;
  /** Preferred travel classes. */
  travelClasses: TravelClass[];
  /** Coach preference of traveler. */
  coachPrefs: CoachPref[];
  /** Preferred rate types. */
  rateTypes: RateTypeV1[];
}

export interface PreferredRailStation {
  /** Name of rail station. */
  stationName: string;
  /** Code of rail station. */
  stationCode: string;
  /** City of rail station. */
  cityName: string;
  /** Country code of rail station. */
  countryCode: string;
  /** Label of preferred rail station, e.g. Home, Work. */
  label: PreferredLocationLabel;
}

export interface SeatPref {
  hasAccessibility: boolean;
  seatTypes: SeatPrefSeatType[];
  seatLocations: SeatPrefSeatLocation[];
  deckLevels: SeatPrefDeckLevel[];
  seatDirections: SeatPrefSeatDirection[];
}

/** Multiple selections for SeatType. */
export enum SeatPrefSeatType {
  SEAT_TYPE_UNKNOWN = 0,
  SLEEPER_BED = 1,
  NORMAL = 2,
  TABLE_SEAT = 3,
  UNRECOGNIZED = -1,
}

/** Multiple selections for SeatLocation. */
export enum SeatPrefSeatLocation {
  SEAT_LOCATION_UNKNOWN = 0,
  AISLE = 1,
  WINDOW = 2,
  SOLO = 3,
  UNRECOGNIZED = -1,
}

/** Multiple selections for DeckLevel. */
export enum SeatPrefDeckLevel {
  DECK_LEVEL_UNKNOWN = 0,
  UPPER_DECK = 1,
  LOWER_DECK = 2,
  UNRECOGNIZED = -1,
}

/** Multiple selections for SeatDirection. */
export enum SeatPrefSeatDirection {
  SEAT_DIRECTION_UNKNOWN = 0,
  FORWARD = 1,
  BACKWARD = 2,
  UNRECOGNIZED = -1,
}
